var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { getOwner } from '@ember/application';
import Service, { inject as service } from '@ember/service';
import SqOneTrust from '@square/one-trust';
import DataApi from '@squareup/data-api.js-core';
import EventstreamClient from 'eventstream.js';
import { FlagNames } from './ember-multipass-flag';
const CDP_PROD_API_KEY = Object.freeze({
  PRODUCTION: '6c294f35-6704-42cd-9105-d087b8265b10',
  OTHER: '3ac24ad1-1049-465f-b3b8-7b82a9eb156e'
});
const QUERY_PARAMS_TO_REDACT = Object.freeze(['v', 'national_phone_number']);

/**
 * Track event data to Square analytics data warehouses.
 *
 * ES2 SDK: https://github.com/squareup/js-sq-ember-eventstream
 * CDP SDK: https://zeroheight.com/55c402603/p/892ab3-client-libraries/b/5417d3
 */
let TrackingService = (_dec = service('eventstream'), _dec2 = service('ember-multipass-eventstream'), _dec3 = service('ember-multipassfe-client'), _dec4 = service('ember-multipass-config'), _dec5 = service('ember-multipass-logging'), _dec6 = service('ember-multipass-flag'), (_class = class TrackingService extends Service {
  constructor() {
    super(...arguments);
    _defineProperty(this, "BUTTON_CLICK_ACTION_NAME", 'button-click');
    _defineProperty(this, "LINK_CLICK_ACTION_NAME", 'link-click');
    _initializerDefineProperty(this, "cookies", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _initializerDefineProperty(this, "hostEventstream", _descriptor3, this);
    _initializerDefineProperty(this, "eventstream", _descriptor4, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor5, this);
    _initializerDefineProperty(this, "multipassConfig", _descriptor6, this);
    _initializerDefineProperty(this, "logger", _descriptor7, this);
    _initializerDefineProperty(this, "flags", _descriptor8, this);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "dataApi", void 0);
    _defineProperty(this, "initialized", false);
    _defineProperty(this, "identified", false);
    // whether this.dataApi.identify was called
    _defineProperty(this, "cdpSessionToken", void 0);
    _defineProperty(this, "userIsActive", false);
    _defineProperty(this, "userActiveEvents", ['load', 'click', 'keypress', 'touchstart', 'mousemove', 'mousedown', 'scroll']);
    _defineProperty(this, "userActiveTimerId", void 0);
    _defineProperty(this, "heartbeatIntervalId", void 0);
    _defineProperty(this, "heartbeatInterval", void 0);
    this.config = getOwner(this).resolveRegistration('config:environment');

    // Initialize ES2
    // Inherit eventstream client from main app if it's available
    // It could be from `sq-ember-eventstream` or main app's `service:eventstream`
    const hostEsClient = this.hostEventstream?.client || getOwner(this).lookup('eventstream-client:main');
    if (hostEsClient) {
      this.eventstream.client = hostEsClient;
    } else {
      // Unlikely to happen, but if it does, log a message to Sentry
      this.logger.sentryMessage(`Failed to find main app eventstream client - ${this.config.APP?.name}`, ['ember-multipass-tracking', 'eventstream-client-not-found', this.config.APP?.name]);
      this.eventstream.client = new EventstreamClient({
        applicationName: this.config.eventstream?.name || this.config.APP?.name || 'ember-multipass-tracking',
        environment: this.config.eventstream?.environment || this.multipassConfig.environment
      });
    }

    // Disable ES2 console logs in production
    if (this.multipassConfig.environment === 'production') {
      this.eventstream.debug = () => true;
    }

    // Initialize CDP
    this.dataApi = DataApi;
    this.handleUserIsActive = this.handleUserIsActive.bind(this);
    this.initialized = true;
  }
  get dataApiKey() {
    if (this.multipassConfig.environment === 'production') {
      return CDP_PROD_API_KEY.PRODUCTION;
    }
    return CDP_PROD_API_KEY.OTHER;
  }
  get redactedEventStream2Fields() {
    const redactedURLResult = this.redactQueryParams(this.getCurrentPageUrl(), QUERY_PARAMS_TO_REDACT);
    const result = {
      webpage_full_url: redactedURLResult.url,
      webpage_search: redactedURLResult.search
    };
    if (this.getCurrentReferrerUrl()) {
      const redactedReferrerURLResult = this.redactQueryParams(this.getCurrentReferrerUrl(), QUERY_PARAMS_TO_REDACT);
      result.webpage_referrer = redactedReferrerURLResult.url;
    }
    return result;
  }
  get redactedCDPContext() {
    const redactedURLResult = this.redactQueryParams(this.getCurrentPageUrl(), QUERY_PARAMS_TO_REDACT);
    const result = {
      page: {
        url: redactedURLResult.url,
        search: redactedURLResult.search
      }
    };
    if (this.getCurrentReferrerUrl()) {
      const redactedReferrerURLResult = this.redactQueryParams(this.getCurrentReferrerUrl(), QUERY_PARAMS_TO_REDACT);
      result.referrer = {
        referrer: redactedReferrerURLResult.url,
        referrerSearch: redactedReferrerURLResult.search
      };
      result.page.referrer = redactedReferrerURLResult.url;
    }
    if (this.cdpSessionToken) {
      result.page.session_token = this.cdpSessionToken;
    }
    return result;
  }
  get redactedCDPProperties() {
    const redactedURLResult = this.redactQueryParams(this.getCurrentPageUrl(), QUERY_PARAMS_TO_REDACT);
    const result = {
      url: redactedURLResult.url,
      search: redactedURLResult.search
    };
    if (this.getCurrentReferrerUrl()) {
      const redactedReferrerURLResult = this.redactQueryParams(this.getCurrentReferrerUrl(), QUERY_PARAMS_TO_REDACT);
      result.referrer = redactedReferrerURLResult.url;
    }
    return result;
  }
  get shouldTrack() {
    const sqOneTrust = new SqOneTrust();
    return this.initialized && ['staging', 'production'].includes(this.multipassConfig.environment) && !sqOneTrust.retargetingOrAdvertisingCookiesBlocked;
  }
  initialize() {
    this.dataApi?.load(this.dataApiKey, this.multipassConfig.environment);
  }
  getCurrentPageUrl() {
    return window.location.href;
  }
  getCurrentReferrerUrl() {
    return document.referrer;
  }
  maybeIdentify() {
    if (!this.shouldTrack || this.identified) {
      return;
    }

    // Already identified by parent app
    if (this.dataApi?.user().id() && this.dataApi?.user().entityType()) {
      this.identified = true;
      return;
    }
    const anonymousId = this.cookies.read('_savt') || this.multipassfeClient.createUUID();
    const cdpIdentifyTraits = {}; // intentionally left empty
    this.dataApi?.identify(anonymousId, 'anonymous_visitor', cdpIdentifyTraits, this.redactedCDPContext);
    this.identified = true;
  }
  trackLinkClick(data) {
    this.trackPageClick(this.LINK_CLICK_ACTION_NAME, data);
  }
  trackButtonClick(data) {
    this.trackPageClick(this.BUTTON_CLICK_ACTION_NAME, data);
  }
  trackPageClick(action, {
    elementText,
    elementTitle,
    elementIdentifier,
    elementType
  } = {}) {
    if (!this.shouldTrack) {
      return;
    }
    this.maybeIdentify();
    const trackingPayload = {
      page_click_action: action,
      page_click_description: elementText,
      element_text: elementText,
      element_identifier: elementIdentifier,
      element_title: elementTitle,
      element_type: elementType
    };
    this.eventstream.trackPageClick({
      ...trackingPayload,
      ...this.redactedEventStream2Fields
    });
    this.dataApi?.track('page click', {
      ...trackingPayload,
      ...this.redactedCDPProperties
    }, this.redactedCDPContext);
  }
  trackRoute({
    pageTitle
  } = {}) {
    this.cdpSessionToken = this.multipassfeClient.createUUID();
    this.trackPageView({
      pageTitle
    });
    this.trackHeartbeat();
  }
  trackEndpoint({
    endpoint,
    isPreCall
  }) {
    const action = isPreCall ? 'pre-call api endpoint' : 'post-call api endpoint';
    try {
      this.trackEvent(action, {
        elementIdentifier: endpoint,
        elementType: 'api endpoint'
      });
    } catch (err) {
      this.logger.error(`Failed to track ${endpoint}`, err.message);
      this.logger.sentryError(['ember-multipass-tracking', 'trackendpoint-failed', this.config.APP?.name], err);
    }
  }
  trackEvent(action, {
    elementIdentifier,
    elementType,
    previousValue,
    newValue
  } = {}) {
    if (!this.shouldTrack) {
      return;
    }
    this.maybeIdentify();
    const trackingPayload = {
      action,
      element_identifier: elementIdentifier,
      element_type: elementType,
      previous_value: previousValue,
      new_value: newValue
    };
    this.eventstream.trackPageClick({
      ...trackingPayload,
      ...this.redactedEventStream2Fields
    });
    this.dataApi?.track(action, {
      ...trackingPayload,
      ...this.redactedCDPProperties
    }, this.redactedCDPContext);
  }
  trackPageView({
    pageTitle,
    pageDescription
  } = {}) {
    if (!this.shouldTrack) {
      return;
    }
    this.maybeIdentify();
    const es2Opts = this.redactedEventStream2Fields;
    const cdpProperties = this.redactedCDPProperties;
    if (pageTitle) {
      es2Opts['webpage_title'] = pageTitle;
      cdpProperties.title = pageTitle;
    }
    if (pageDescription) {
      es2Opts.page_view_description = pageDescription;
      cdpProperties.description = pageDescription;
    }
    const routeName = this.router.currentRouteName;
    this.eventstream.trackPageView(routeName, es2Opts);
    this.dataApi?.page(routeName, cdpProperties, this.redactedCDPContext);
  }

  /**
   * Maintain user's active state by listening certain events
   * If user is active, send heartbeat event to CDP every interval_seconds
   */
  trackHeartbeat() {
    this.stopHeartbeat();
    const intervalSeconds = this.flags.getValue(FlagNames.CDP_HEARTBEAT_INTERVAL_SECONDS);
    if (!intervalSeconds || typeof intervalSeconds !== 'number' || intervalSeconds < 0) {
      return;
    }
    this.heartbeatInterval = intervalSeconds * 1000;
    this.trackIsUserActive();
    this.cdpTrackHeartbeat();
    this.heartbeatIntervalId = setInterval(() => {
      if (this.userIsActive) {
        this.cdpTrackHeartbeat();
      }
    }, this.heartbeatInterval);
  }
  cdpTrackHeartbeat() {
    if (!this.shouldTrack) {
      return;
    }
    const cdpContext = {
      integrations: {
        all: false,
        snowflake: true
      }
    };
    this.dataApi?.track('Heartbeat', {
      square_geo: this.cookies.read('squareGeo')
    }, {
      ...cdpContext,
      ...this.redactedCDPContext
    });
  }
  trackIsUserActive() {
    this.userActiveEvents.forEach(event => {
      window.addEventListener(event, this.handleUserIsActive, true);
    });
  }
  handleUserIsActive() {
    clearTimeout(this.userActiveTimerId);
    this.userIsActive = true;
    // set new timer to inactivate user
    this.userActiveTimerId = setTimeout(() => {
      this.userIsActive = false;
    }, this.heartbeatInterval);
  }

  /**
   * Remove all the listeners and timers from the previous tracked route
   */
  stopHeartbeat() {
    this.userActiveEvents.forEach(event => {
      window.removeEventListener(event, this.handleUserIsActive, true);
    });
    clearInterval(this.heartbeatIntervalId);
    clearTimeout(this.userActiveTimerId);
  }

  /**
   * [VULN-63269]/[INV-647] To support redacting sensitive query strings from URL.
   *
   * @typedef {Object} RedactionResult
   * @property {string} url - URL string
   * @property {string|undefined} search - Search string
   *
   * @param inputUrl {string}
   * @param queryParamsToRedact {string[]}
   * @returns {RedactionResult} result
   */
  redactQueryParams(inputUrl, queryParamsToRedact) {
    try {
      const url = new URL(inputUrl);
      const originalParams = url.searchParams;
      for (const param of queryParamsToRedact) {
        if (originalParams.has(param)) {
          originalParams.set(param, 'REDACTED_TOKEN');
        }
      }
      return {
        url: url.toString(),
        search: url.search
      };
    } catch (e) {
      this.logger.error(`Failed to redact url ${inputUrl}`, e);
      return {
        url: inputUrl,
        search: undefined
      };
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cookies", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "hostEventstream", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "eventstream", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "multipassConfig", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "flags", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { TrackingService as default };